
import { endOfMonth, format, isWithinInterval, startOfMonth, startOfDay, endOfDay, subDays } from 'date-fns';
import { pt } from 'date-fns/locale';
import { Component, Vue } from 'vue-property-decorator';
import Planning from './Planning.vue';
import { performanceIndicatorStore, userActionStore } from '@/store';
import { IPerformanceIndicatorAnswer } from '@/interfaces/performance_indicator';

@Component({
  components: {
    Planning,
  },
})
export default class List extends Vue {
  rowDateC = 'totalC';
  rowDateP = 'totalP';
  showMain = true;
  departmentId = 0;
  selectedMonth = null;
  performanceIndicatorAnswer: IPerformanceIndicatorAnswer[] = [];
  selectedDptoItems: IPerformanceIndicatorAnswer = {};

  get currentMonth() {
    const wordMonth = format(new Date(), 'MMMM', { locale: pt });
    const capitalized = wordMonth[0].toUpperCase() + wordMonth.substring(1);
    return capitalized;
  }

  get permissionCreate() {
    return userActionStore.CriarPerguntasIndicadoresPerformance;
  }

  filterDateC(answers: IPerformanceIndicatorAnswer) {
    const now = new Date();
    const todayStart = startOfDay(now);
    const todayEnd = endOfDay(now);
    const lastWeekStart = subDays(todayStart, 7);
    const lastFifteenDaysStart = subDays(todayStart, 15);
    const monthStart = startOfMonth(now);
    const monthEnd = endOfMonth(now);

    const dateFilters = {
      todayC: (answerDate) => isWithinInterval(answerDate, { start: todayStart, end: todayEnd }),
      lastWeekC: (answerDate) => isWithinInterval(answerDate, { start: lastWeekStart, end: todayEnd }),
      lastFifteenDaysC: (answerDate) =>
        isWithinInterval(answerDate, {
          start: lastFifteenDaysStart,
          end: todayEnd,
        }),
      totalC: (answerDate) => isWithinInterval(answerDate, { start: monthStart, end: monthEnd }),
    };

    let filteredAnswers: IPerformanceIndicatorAnswer = {};

    for (const campaign in answers) {
      const campaignAnswers = answers[campaign].filter((answer) => {
        const answerDate = new Date(answer.answer_created_at);
        const filterFunction = dateFilters[this.rowDateC];
        return filterFunction ? filterFunction(answerDate) : true;
      });

      if (campaignAnswers.length > 0) {
        filteredAnswers[campaign] = campaignAnswers;
      }
    }

    return filteredAnswers;
  }

  filterDateP(answers: IPerformanceIndicatorAnswer) {
    const now = new Date();
    const todayStart = startOfDay(now);
    const todayEnd = endOfDay(now);
    const lastWeekStart = subDays(todayStart, 7);
    const lastFifteenDaysStart = subDays(todayStart, 15);
    const monthStart = startOfMonth(now);
    const monthEnd = endOfMonth(now);

    const dateFilters = {
      todayP: (answerDate) => isWithinInterval(answerDate, { start: todayStart, end: todayEnd }),
      lastWeekP: (answerDate) => isWithinInterval(answerDate, { start: lastWeekStart, end: todayEnd }),
      lastFifteenDaysP: (answerDate) =>
        isWithinInterval(answerDate, {
          start: lastFifteenDaysStart,
          end: todayEnd,
        }),
      totalP: (answerDate) => isWithinInterval(answerDate, { start: monthStart, end: monthEnd }),
    };

    let filteredAnswers: IPerformanceIndicatorAnswer = {};

    for (const campaign in answers) {
      const campaignAnswers = answers[campaign].filter((answer) => {
        const answerDate = new Date(answer.answer_created_at);
        const filterFunction = dateFilters[this.rowDateP];
        return filterFunction ? filterFunction(answerDate) : true;
      });

      if (campaignAnswers.length > 0) {
        filteredAnswers[campaign] = campaignAnswers;
      }
    }

    return filteredAnswers;
  }

  filterSelectedMonth(answers: IPerformanceIndicatorAnswer) {
    const filteredAnswers: IPerformanceIndicatorAnswer = {};
    const now = new Date();

    for (const nameAnswer in answers) {
      const campaignAnswers = answers[nameAnswer].filter((answer: IPerformanceIndicatorAnswer) => {
        const eventDate = new Date(answer.answer_created_at);
        const monthStart = startOfMonth(now.setMonth(this.selectedMonth));
        const monthEnd = endOfMonth(now.setMonth(this.selectedMonth));
        return isWithinInterval(eventDate, {
          start: monthStart,
          end: monthEnd,
        });
      });

      if (campaignAnswers.length > 0) {
        filteredAnswers[nameAnswer] = campaignAnswers;
      }
    }
    return filteredAnswers;
  }

  get sumTotalFranchisee() {
    return performanceIndicatorStore.performance_indicator_answer_total_franchisee;
  }

  handleDeparture(id: number) {
    this.departmentId = Number(id);
    this.showMain = false;
    this.selectedDptoItems = this.performanceIndicatorAnswer[id];
  }

  get showDeparture() {
    return new Set(Object.keys(this.performanceIndicatorAnswer));
  }

  getDepartureName(id: number) {
    return this.departureOptions().find((i: any) => i.id === Number(id)).name;
  }

  async mounted() {
    this.performanceIndicatorAnswer = await performanceIndicatorStore.getPerformanceIndicatorAnswerDepartureId();
    await performanceIndicatorStore.getPerformanceIndicatorAnswerTotalCompanyCurrentMonth();
    await userActionStore.getUserActions();
  }
}
